import { Component, Inject } from '@angular/core';
import { AccountPledgeFailedDialogData, AccountPledgeData } from "../account-pledge.model";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: 'ifb-account-pledge-failed-dialog',
    templateUrl: './account-pledge-failed-dialog.component.html',
    styleUrls: ['./account-pledge-failed-dialog.component.scss'],
    standalone: false
})
export class AccountPledgeFailedDialogComponent {
  unsuccessfulLoans : AccountPledgeData[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AccountPledgeFailedDialogData) {
    this.unsuccessfulLoans = data?.unsuccessfulLoans ?? [];
  }
}
